import React from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';
import { ActivityLogListContainer } from '../ActivityLogListContainer';
import ActivityLogInlineFilters from './ActivityLogInlineFilters';
import { useActivityLog } from '../useActivityLog';

export interface ActivityLogInlineProps {
  entityFilters: {};
}

export function ActivityLogInline({ entityFilters }: ActivityLogInlineProps) {
  const history = useHistory();

  const {
    state,
    loadingMore,
    showActivities,
    showSkeleton,
    noActivitiesFound,
    sentryRef,
    getAppliedFilters,
    resetFilter,
    updateFilter,
    refresh
  } = useActivityLog({ loadFilters: true, entityFilters });

  const routerPush = path => {
    history.push(path);
  };

  return (
    <div>
      <ActivityLogInlineFilters
        filters={state.listFilters}
        loading={state.activities.length === 0 && state.fetchingList}
        appliedFilters={getAppliedFilters()}
        resetFilter={resetFilter}
        updateFilter={updateFilter}
        onRefreshCallback={refresh}
        routerPush={routerPush}
      />

      <ActivityLogListContainer
        state={state}
        sentryRef={sentryRef}
        noActivitiesFound={noActivitiesFound}
        showSkeleton={showSkeleton}
        showActivities={showActivities}
        loadingMore={loadingMore}
        refresh={refresh}
      />
    </div>
  );
}
